import { authConstants } from '../constants'

const login = (user) => {
    localStorage.setItem('token', user.token)
    localStorage.setItem('token_expired', +new Date())

  return {
    type: authConstants.LOGIN,
    user,
  };
};

const logout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem("token_expired");

  return {
    type: authConstants.LOGOUT,
  };
};

export const authActions = {
    login,
    logout
}
